import { algoliasearch } from 'algoliasearch';

// Initialize Algolia client
const searchClient = algoliasearch(
  import.meta.env.VITE_ALGOLIA_APP_ID,
  import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY
);

// Determine environment
const isQaEnvironment = import.meta.env.VITE_API_BASE_ENVIRONMENT === 'QA' || import.meta.env.VITE_API_BASE_ENVIRONMENT === 'DEVELOPMENT';
const indexPrefix = isQaEnvironment ? 'qa_' : '';

// Define indices
export const ALGOLIA_INDICES = {
  SHIPMENTS: `${indexPrefix}shipments`,
  PURCHASE_ORDERS: `${indexPrefix}purchase_orders`,
  DELIVERIES: `${indexPrefix}deliveries`,
  WAREHOUSES: `${indexPrefix}warehouses`,
  QUOTES: `${indexPrefix}quotes`,
  SHIPMENT_ITEMS: `${indexPrefix}shipment_items`,
  PURCHASE_ORDERS_ITEMS: `${indexPrefix}purchase_orders_items`
} as const;

export const DEFAULT_SEARCH_INDICES = [
  ALGOLIA_INDICES.SHIPMENTS,
  ALGOLIA_INDICES.PURCHASE_ORDERS
];

// Type for search results
export interface SearchResult {
  objectID: string;
  type: keyof typeof ALGOLIA_INDICES;
  title: string;
  description: string;
  url: string;
  [key: string]: any;
}

export { searchClient };
